export default __webpack_public_path__ + "static/media/icon-delete-red.37407c1a.svg";